/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const edit = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.865 1.94.258-.258a2.265 2.265 0 0 1 3.217-.022 2.262 2.262 0 0 1-.022 3.216l-.258.258-8.764 8.764L1 15l1.101-4.296 8.764-8.765Zm3.195 3.194L10.865 1.94"
    />
  </svg>
)
export default edit
